import { Effect, Reducer } from 'umi';

const namespace = 'opinionFilterCond';
type stateType = any;

const customModel: {
  effects: {};
  namespace: string;
  state: stateType;
  reducers: {
    save: Reducer<stateType>;
  };
} = {
  namespace,
  state: {
    gameInfo: {},
    channelSource: {},
    channelList: [],
  },
  reducers: {
    save(state: stateType, { payload }) {
      return { ...state, ...payload };
    },
  },
  effects: {},
};

export default customModel;
